var user = JSON.parse(localStorage.getItem('user') ?? "{}")

export default
  [
    {
      title: "الرئيسية",
      route: 'home',
      icon: 'HomeIcon',
    },
  ].filter(function(x){
    return x;
    if(user?.pers?.includes("*")){
      return x;
    }else{
      if(!x.per || user.pers.includes(x.per)){
        return x;
      }
    }
    return false;
  });
